export default __webpack_public_path__ + "static/benefit-3-0572d7ef2fff25c9f5ab6b718e41db03.webp";